module.exports = __webpack_public_path__ + "img/Notify_success.35afbaa8.jpg";